import React from 'react'
import ReactDOM from 'react-dom'
import CobaltRoot from '@cobalt/cobalt-react-components'
import RouterRoot from './root'
import { ErrorBoundary } from 'react-error-boundary'

window.TalkdeskApps = window.TalkdeskApps || {}

window.TalkdeskApps.TalkdeskIdLoginUi = {
  start: function(rootElement, params) {
    startApp(rootElement, params)
  },
  stop: function(rootElement) {
    ReactDOM.unmountComponentAtNode(rootElement)
  },
  version: __APP_VERSION__
}

function startApp(rootElement, params) {
  const { themeVersion } = params
  let themeLoader

  if (themeVersion) {
    console.log(`Using theme version: ${themeVersion}`)
    themeLoader = async () => {
      return null
    }
  } else {
    console.log('Using default theme')
    themeLoader = async () => {}
  }

  ReactDOM.render(
    <ErrorBoundary
      onError={(error, errorInfo) =>
        console.log(`Error: ${error}, Error Info: ${errorInfo}`)
      }
    >
      <CobaltRoot loadBundle={themeLoader}>
        <RouterRoot {...params} />
      </CobaltRoot>
    </ErrorBoundary>,
    rootElement
  )
}
